import animateScrollTo from 'animated-scroll-to';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { slugify } from '../../shared/helpers';
import { StateType } from '../../reducers';
import { getUserIdFromUserSelector } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { HOCPanel } from '../Panel/Panel';

import { LearnContent } from './LearnDetailsContent/LearnContent';
import { PanelFooter } from './LearnDetailsContent/PanelFooter';
import { PanelHeader } from './LearnDetailsContent/PanelHeader';
import { BackToTop } from './BackToTop/BackToTop';
import { markPageAsVisited } from './hooks/useLastVisited';

interface LearnMainItemProps {
  fetchingData: boolean;
  item: any;
  pageId: string;
  nextLink?: string;
  nextLinkLabel?: string;
  prevLink?: string;
  prevLinkLabel?: string;
  headerIndex?: any;
  title: string;
  titleModifiers: any;
  scrollElement?: string;
  path?: string;
  // This function will handle the clone alpha when the user is on the simulate page
  handleSimulateClone?: (alpha: string) => void;
  learnBlockId?: string;
  handleShowModal?: () => boolean;
  isMultiTab?: boolean;
}

interface LearnMainItemStateProps {
  userId: string;
}

type LearnMainItemGenericProps = LearnMainItemProps & LearnMainItemStateProps;

interface LearnMainItemState {
  activeAccordions: any;
}

const Panel = HOCPanel(PanelHeader, PanelFooter);

class LearnMainItemImpl extends React.Component<LearnMainItemGenericProps, LearnMainItemState> {
  constructor(props: LearnMainItemGenericProps) {
    super(props);
    this.state = {
      activeAccordions: {},
    };
  }

  setAccordionQuestion(question: string) {
    const newActiveAccordions = Object.assign(this.state.activeAccordions);
    newActiveAccordions[slugify(question)] = false;
    newActiveAccordions[window.location.hash.substring(1)] = true;
    this.setState({ activeAccordions: newActiveAccordions });
  }

  componentDidMount() {
    void markPageAsVisited(this.props.userId, this.props.pageId);

    const element = this.props.scrollElement ? document.querySelector(this.props.scrollElement) : null;
    if (element) {
      animateScrollTo(document.getElementById(window.location.hash.substring(1)), { element });
    } else {
      animateScrollTo(document.getElementById(window.location.hash.substring(1)));
    }
  }

  toggleAccordion = (question: any) => () => {
    const newActiveAccordions = Object.assign(this.state.activeAccordions);
    newActiveAccordions[slugify(question)] = !this.state.activeAccordions[slugify(question)];
    this.setState({ activeAccordions: newActiveAccordions });
  };

  render() {
    const { item, nextLink, nextLinkLabel, prevLink, prevLinkLabel, headerIndex, title, titleModifiers, path = 'learn' } = this.props;

    return (
      <>
        <Helmet title={this.props.title} />
        <Panel
          title={title}
          titleModifiers={titleModifiers}
          panelModifiers={['learn']}
          firstLink={{ url: prevLink, label: prevLinkLabel }}
          nextLink={{ url: nextLink, label: nextLinkLabel, color: 'back-blue' }}
          path={path}
        >
          <div className="tutorials-concepts">
            <LearnContent
              item={item}
              headerIndex={headerIndex}
              scrollElement={this.props.scrollElement}
              handleSimulateClone={this.props.handleSimulateClone}
              handleShowModal={this.props.handleShowModal}
              isMultiTab={this.props.isMultiTab}
            />
          </div>
        </Panel>
        <BackToTop />
      </>
    );
  }
}

const mapStateToProps = (state: StateType): LearnMainItemStateProps => ({
  userId: getUserIdFromUserSelector(state),
});

export const LearnMainItem = connect<LearnMainItemStateProps, any, any, StateType>(mapStateToProps)(LearnMainItemImpl);
